<ion-card>
  <ion-card-header>
    <ion-card-title>Menüszerkesztő</ion-card-title>
    <ion-card-subtitle>A bal oldali menü átrendezése húzással</ion-card-subtitle>
  </ion-card-header>

  <ion-card-content>
    <!-- A funkció határa: ezt tudni kell HASZNÁLAT ELŐTT, különben az admin azt
         keresi, hol állítja be külön a pedagógusok menüjét. -->
    <ion-note color="medium" class="msz-bevezeto">
      A menü <b>elrendezése</b> (sorrend, csoport, cím, ikon) alapból intézményenként
      <b>közös</b>. Ha fent kiválasztasz egy jogkört, az átrendezés, az átnevezés és az ikon
      <b>csak annak a jogkörnek</b> az oldalsávjára vonatkozik (a többi jogkör, az admin sem
      örökli). Új menüpontot felvenni, törölni és letiltani a közös szerkezetben lehet.<br>
      Soronként két, egymástól független kapcsoló van. A <b>kulcs</b> a <b>jogosultság</b>:
      megnyílik-e neki a képernyő. A <b>szem</b> az <b>elrejtés</b>: ott van-e az
      oldalsávban — ez a jogosultságot nem érinti, és <b>bármelyik jogkörnél</b> működik.
      Jogkör kiválasztása nélkül az elrejtés <b>mindenkire</b> vonatkozik.
    </ion-note>

    <div class="msz-vezerlok">
      <ion-select label="Alrendszer" label-placement="stacked" interface="popover" fill="outline"
                  [(ngModel)]="alrendszer" (ionChange)="betolt()">
        <ion-select-option *ngFor="let a of alrendszerek" [value]="a">{{ a }}</ion-select-option>
      </ion-select>

      <ion-select label="Kinek a szemével?" label-placement="stacked" interface="popover" fill="outline"
                  [ngModel]="nezoJogkor" (ngModelChange)="nezoValt($event)">
        <ion-select-option value="">Közös szerkezet — mindenkire</ion-select-option>
        <ion-select-option *ngFor="let j of jogkorok" [value]="j.jogkor">{{ j.name }}</ion-select-option>
      </ion-select>

      <div class="msz-gombok">
        <ion-button fill="outline" color="primary" (click)="ujMegnyit()" *ngIf="!nezoJogkor">
          <ion-icon slot="start" name="add-circle-outline"></ion-icon>
          Új menüpont
        </ion-button>
        <ion-button color="primary" [disabled]="!menthet" (click)="ment()">
          <ion-icon slot="start" name="save-outline"></ion-icon>
          {{ mentesFut ? 'Mentés…' : 'Mentés' }}
        </ion-button>
        <ion-button fill="outline" color="medium" [disabled]="!menthet" (click)="elvet()">Elvetés</ion-button>
        <ion-button fill="outline" color="warning" *ngIf="nezoJogkor && sajatElrendezes"
                    [disabled]="mentesFut" (click)="elrendezesVissza()"
                    title="Ennek a jogkörnek a saját elrendezését törli – utána a közös szerkezet érvényes rá">
          Vissza a közös elrendezésre
        </ion-button>
      </div>
    </div>

    <!--  ÚJ MENÜPONT. Az url a menüpont azonossága – arra hivatkozik a jogosultság –,
          ezért itt kell megadni, és utólag nem írható át.  -->
    <div class="msz-uj" *ngIf="ujNyitva">
      <div class="msz-uj-sor">
        <ion-input label="Név" label-placement="stacked" fill="outline"
                   placeholder="ami a menüben látszik" [(ngModel)]="ujTetel.title"></ion-input>
        <ion-input label="Útvonal" label-placement="stacked" fill="outline"
                   [placeholder]="ujTetel.fejlec ? 'pl. suli-naplo' : 'pl. /tanmenet vagy https://…'"
                   [(ngModel)]="ujTetel.url"></ion-input>
        <ion-input label="Ikon" label-placement="stacked" fill="outline"
                   placeholder="pl. school" [(ngModel)]="ujTetel.icon"></ion-input>
        <ion-select label="Csoportba" label-placement="stacked" interface="popover" fill="outline"
                    [(ngModel)]="ujTetel.main" [disabled]="ujTetel.fejlec">
          <ion-select-option value="">— felső szintre —</ion-select-option>
          <ion-select-option *ngFor="let f of fejlecek" [value]="f.id">{{ f.title }}</ion-select-option>
        </ion-select>
      </div>
      <div class="msz-uj-sor">
        <label class="msz-kapcs">
          <input type="checkbox" [(ngModel)]="ujTetel.fejlec" />
          Ez egy <b>csoportfejléc</b> (nem képernyő, csak nyitható csoport)
        </label>
        <label class="msz-kapcs" [class.msz-tiltott]="ujKulsoCim">
          <input type="checkbox" [(ngModel)]="ujTetel.external" [disabled]="ujKulsoCim || ujTetel.fejlec" />
          <b>Új oldalon nyíljon meg</b>
          <span *ngIf="ujKulsoCim"> — külső címnél kötelező</span>
        </label>
        <ion-button size="small" color="primary" (click)="ujFelvesz()">Hozzáadás a listához</ion-button>
        <ion-button size="small" fill="clear" color="medium" (click)="ujNyitva = false">Mégsem</ion-button>
      </div>
      <ion-note color="medium" class="msz-jelzes">
        A menüpont a <b>Mentés</b> gombbal jön létre. Új képernyő <b>mindenki elől zárva</b>
        születik: a jogkör-választóval add meg, kik lássák — enélkül csak a mindent látó
        jogkör találja meg.
      </ion-note>
    </div>

    <ion-note color="medium" *ngIf="nezoMindentLat" class="msz-jelzes">
      Ez a jogkör <b>mindent lát</b> (csillag jogosultsága van), ezért a kulcs itt nem
      soronként áll — a csillag jog nem bontható menüpontokra. <b>Elrejteni viszont
      lehet</b>: az elrejtés csak az oldalsávra hat, a jogosultság megmarad, és az
      elrejtett képernyő közvetlen hivatkozással továbbra is megnyílik.
    </ion-note>

    <ion-note color="primary" *ngIf="nezoJogkor" class="msz-jelzes">
      A(z) <b>{{ jogkorNev(nezoJogkor) }}</b> jogkör <b>saját elrendezését</b> szerkeszted:
      a sorrend, a csoport, a név és az ikon csak az ő menüjében változik.
      <span *ngIf="sajatElrendezes">Ennek a jogkörnek már van saját elrendezése.</span>
      <span *ngIf="!sajatElrendezes">Még nincs saját elrendezése – most a közöset látod; mentéskor ebből lesz az övé.</span>
      A jogosultság (kulcs) öröklődik: amit a pedagógusnak megadsz, azt a rá épülő jogkörök
      (pl. osztályfőnök, igazgató, admin) is megkapják. Az elrejtés (szem) csak erre a jogkörre hat.
    </ion-note>

    <ion-note color="medium" *ngIf="!nezoJogkor" class="msz-jelzes">
      Most a <b>szerkezetet</b> szerkeszted. A szem itt <b>mindenki elől</b> rejti el a
      menüpontot — jogkörtől függetlenül, a jogosultság érintése nélkül. Egy jogkör
      kiválasztásával csak az ő menüjéből tudsz elvenni.
    </ion-note>

    <ion-note color="danger" *ngIf="hiba" class="msz-jelzes">{{ hiba }}</ion-note>

    <div *ngIf="toltodik" class="msz-uzenet"><ion-spinner name="dots"></ion-spinner> Betöltés…</div>

    <div class="msz-fa" *ngIf="!toltodik && felso.length" cdkDropListGroup>
      <div cdkDropList id="felso" [cdkDropListData]="felso"
           [cdkDropListConnectedTo]="listaAzonositok" (cdkDropListDropped)="ejtFelso($event)">

        <div class="msz-elem-burok" *ngFor="let e of felso" cdkDrag [cdkDragData]="e">
          <div class="msz-elem" [class.fejlec]="e.fejlec" [class.rejtve]="!latja(e)"
               [class.torlendo]="torlesreJelolt(e)"
               [class.tiltva]="e.disabled">
            <ion-icon class="msz-fogo" name="reorder-three-outline" cdkDragHandle></ion-icon>
            <ion-icon class="msz-ikon" [name]="(e.icon || 'ellipse') + '-outline'"></ion-icon>

            <input class="msz-cim" [(ngModel)]="e.title" (ngModelChange)="modosult()"
                   [attr.aria-label]="'Menüpont neve'">
            <input class="msz-ikonnev" [(ngModel)]="e.icon" (ngModelChange)="modosult()"
                   placeholder="ikon" title="Ionicons név, végződés nélkül (pl. school)">
            <code class="msz-url">{{ e.url }}</code>

            <!-- JOGOSULTSÁG: megnyílik-e neki a képernyő. -->
            <ion-button size="small" fill="clear" *ngIf="nezoJogkor" [disabled]="nezoMindentLat"
                        [color]="vanJoga(e) ? (sajatJoga(e) ? 'success' : 'warning') : 'medium'"
                        (click)="jogValt(e)" [title]="jogCim(e)">
              <!--  Örökölt jog: más jel, mint a sajátnál. Ugyanaz a zöld kulcs azt
                    sugallná, hogy itt keletkezett – pedig a szülő jogkörből jön. -->
              <ion-icon slot="icon-only"
                        [name]="!vanJoga(e) ? 'lock-closed-outline' : (sajatJoga(e) ? 'key-outline' : 'git-branch-outline')"></ion-icon>
            </ion-button>
            <ion-note class="msz-orokolt" *ngIf="nezoJogkor && !nezoMindentLat && !sajatJoga(e) && oroklottNev(e)"
                      [title]="'Örökölt jog: ' + oroklottNev(e)">örökölt</ion-note>

            <!--  TÖRLÉS. Mentésig visszavonható, addig a sor áthúzva marad – így
                  látszik, mi fog eltűnni, nem pedig csendben kiürül a lista. -->
            <ion-button size="small" fill="clear" *ngIf="!nezoJogkor" [color]="torlesreJelolt(e) ? 'warning' : 'danger'"
                        (click)="torlesValt(e)"
                        [title]="torlesreJelolt(e) ? 'Mégsem törlöm' : 'Menüpont törlése (mentéskor)'">
              <ion-icon slot="icon-only"
                        [name]="torlesreJelolt(e) ? 'arrow-undo-outline' : 'trash-outline'"></ion-icon>
            </ion-button>

            <!-- ELREJTÉS: csak az oldalsávra hat, a jogosultságot nem érinti. -->
            <ion-button size="small" fill="clear"
                        [color]="rejtett(e) ? 'medium' : 'success'" (click)="rejtesValt(e)"
                        [title]="rejtesCim(e)">
              <ion-icon slot="icon-only" [name]="rejtett(e) ? 'eye-off-outline' : 'eye-outline'"></ion-icon>
            </ion-button>
            <ion-note class="msz-rejtve" *ngIf="rejtett(e)"
                      [title]="mindenkiElol(e) ? 'Mindenki elől elrejtve – a jogosultság megmaradt' : 'Ez elől a jogkör elől elrejtve – a jogosultság megmaradt'">
              {{ mindenkiElol(e) ? 'elrejtve (mindenki)' : 'elrejtve' }}
            </ion-note>

            <ion-button size="small" fill="clear" *ngIf="!e.fejlec && !nezoJogkor"
                        [color]="e.external ? 'primary' : 'medium'" (click)="externalValt(e)"
                        [title]="e.external ? 'Új oldalon nyílik meg' : 'A programon belül nyílik meg'">
              <ion-icon slot="icon-only" [name]="e.external ? 'open-outline' : 'return-down-forward-outline'"></ion-icon>
            </ion-button>
            <ion-note class="msz-uj-jel" *ngIf="e.uj">új — mentésre vár
              <ion-button size="small" fill="clear" color="danger" (click)="ujElvet(e)" title="Elvetés">
                <ion-icon slot="icon-only" name="close-outline"></ion-icon>
              </ion-button>
            </ion-note>

            <ion-button size="small" fill="clear" *ngIf="!nezoJogkor" [color]="e.disabled ? 'danger' : 'medium'"
                        (click)="e.disabled = e.disabled ? 0 : 1; modosult()"
                        [title]="e.disabled ? 'Letiltva – szürkén, kattinthatatlanul jelenik meg. Elrejteni a szemmel lehet.' : 'Aktív'">
              <ion-icon slot="icon-only" [name]="e.disabled ? 'ban-outline' : 'checkmark-circle-outline'"></ion-icon>
            </ion-button>
          </div>

          <!-- Csoport gyerekei: külön ejtőlista, hogy át lehessen húzni közöttük. -->
          <div class="msz-csoport" *ngIf="e.fejlec">
            <ion-note color="warning" class="msz-figy" *ngIf="fejlecHiany(e)">
              A csoportfejléc nem jelenik meg{{ nezoJogkor ? ' ennek a jogkörnek' : '' }}, a
              benne lévő pontok viszont igen — azok <b>felső szinten</b> fognak megjelenni,
              csoport nélkül.
            </ion-note>

            <div cdkDropList [id]="'cs-' + e.id" [cdkDropListData]="e.gyerekek"
                 [cdkDropListConnectedTo]="listaAzonositok"
                 (cdkDropListDropped)="ejtCsoport($event, e)" class="msz-gyereklista">

              <div class="msz-elem gyerek" *ngFor="let gy of e.gyerekek" cdkDrag [cdkDragData]="gy"
                   [class.rejtve]="!latja(gy)" [class.tiltva]="gy.disabled"
                   [class.torlendo]="torlesreJelolt(gy)">
                <ion-icon class="msz-fogo" name="reorder-three-outline" cdkDragHandle></ion-icon>
                <ion-icon class="msz-ikon" [name]="(gy.icon || 'ellipse') + '-outline'"></ion-icon>

                <input class="msz-cim" [(ngModel)]="gy.title" (ngModelChange)="modosult()">
                <input class="msz-ikonnev" [(ngModel)]="gy.icon" (ngModelChange)="modosult()"
                       placeholder="ikon">
                <code class="msz-url">{{ gy.url }}</code>

                <ion-button size="small" fill="clear" *ngIf="nezoJogkor" [disabled]="nezoMindentLat"
                            [color]="vanJoga(gy) ? (sajatJoga(gy) ? 'success' : 'warning') : 'medium'" (click)="jogValt(gy)"
                            [title]="jogCim(gy)">
                  <ion-icon slot="icon-only"
                            [name]="!vanJoga(gy) ? 'lock-closed-outline' : (sajatJoga(gy) ? 'key-outline' : 'git-branch-outline')"></ion-icon>
                </ion-button>
                <ion-note class="msz-orokolt" *ngIf="nezoJogkor && !nezoMindentLat && !sajatJoga(gy) && oroklottNev(gy)"
                          [title]="'Örökölt jog: ' + oroklottNev(gy)">örökölt</ion-note>

                <ion-button size="small" fill="clear" *ngIf="!nezoJogkor" [color]="torlesreJelolt(gy) ? 'warning' : 'danger'"
                            (click)="torlesValt(gy)"
                            [title]="torlesreJelolt(gy) ? 'Mégsem törlöm' : 'Menüpont törlése (mentéskor)'">
                  <ion-icon slot="icon-only"
                            [name]="torlesreJelolt(gy) ? 'arrow-undo-outline' : 'trash-outline'"></ion-icon>
                </ion-button>
                <ion-button size="small" fill="clear"
                            [color]="rejtett(gy) ? 'medium' : 'success'" (click)="rejtesValt(gy)"
                            [title]="rejtesCim(gy)">
                  <ion-icon slot="icon-only" [name]="rejtett(gy) ? 'eye-off-outline' : 'eye-outline'"></ion-icon>
                </ion-button>
                <ion-note class="msz-rejtve" *ngIf="rejtett(gy)"
                          [title]="mindenkiElol(gy) ? 'Mindenki elől elrejtve – a jogosultság megmaradt' : 'Ez elől a jogkör elől elrejtve – a jogosultság megmaradt'">
                  {{ mindenkiElol(gy) ? 'elrejtve (mindenki)' : 'elrejtve' }}
                </ion-note>
                <ion-button size="small" fill="clear" *ngIf="!nezoJogkor"
                            [color]="gy.external ? 'primary' : 'medium'" (click)="externalValt(gy)"
                            [title]="gy.external ? 'Új oldalon nyílik meg' : 'A programon belül nyílik meg'">
                  <ion-icon slot="icon-only" [name]="gy.external ? 'open-outline' : 'return-down-forward-outline'"></ion-icon>
                </ion-button>
                <ion-note class="msz-uj-jel" *ngIf="gy.uj">új
                  <ion-button size="small" fill="clear" color="danger" (click)="ujElvet(gy, e)" title="Elvetés">
                    <ion-icon slot="icon-only" name="close-outline"></ion-icon>
                  </ion-button>
                </ion-note>
                <ion-button size="small" fill="clear" *ngIf="!nezoJogkor" [color]="gy.disabled ? 'danger' : 'medium'"
                            (click)="gy.disabled = gy.disabled ? 0 : 1; modosult()"
                            [title]="gy.disabled ? 'Letiltva – szürkén, kattinthatatlanul jelenik meg' : 'Aktív'">
                  <ion-icon slot="icon-only" [name]="gy.disabled ? 'ban-outline' : 'checkmark-circle-outline'"></ion-icon>
                </ion-button>
                <!-- Érintőképernyőn a húzás nehézkes: kivétel gombbal is megy. -->
                <ion-button size="small" fill="clear" color="medium" (click)="felsobe(gy, e)"
                            title="Kivétel a csoportból">
                  <ion-icon slot="icon-only" name="arrow-up-outline"></ion-icon>
                </ion-button>
              </div>

              <div class="msz-ures" *ngIf="!e.gyerekek.length">Ide húzhatsz menüpontot.</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ion-note color="medium" class="msz-labjegyzet" *ngIf="!toltodik && felso.length">
      Az <b>ikon</b> neve végződés nélkül írandó (pl. <code>school</code>, <code>laptop</code>) —
      az oldalsáv maga fűzi hozzá a platformnak megfelelő változatot. A menüpont
      <b>címe</b> szabadon átírható, az útvonala nem: arra hivatkozik a jogosultság.<br>
      A <b>nyíl</b> ikon azt mondja meg, hogy a menüpont a programon belül vagy
      <b>új oldalon</b> nyíljon meg. Külső hivatkozás (teljes cím) mindig új oldalon
      nyílik — útvonalként a rendszer a saját címei közt keresné.
    </ion-note>
  </ion-card-content>
</ion-card>
